import { sanitize } from "dompurify";

const DimensionDescriptionTextLayout = ({ data }) => {
  const sanitizedText = sanitize(data.text, { ADD_ATTR: ["target"] });
  return <div className="h5" dangerouslySetInnerHTML={{ __html: sanitizedText }}></div>;
};

export default DimensionDescriptionTextLayout;
